import styled from "styled-components";
import { ButtonGhost } from "./Button/Button";
import { ReactComponent as GenericErrorIcon } from "../assets/icons/generic_error.svg";
import { useDispatch } from "react-redux";
import { hideModal } from "../redux/modal/modal.slice";
import { t } from "i18next";

export const ErrorIcon = styled.div`
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.danger100};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.netural800};
  margin: 0;
  margin-top: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const ModalMessage = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.netural600};
  margin: 0;
  margin-bottom: 24px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    min-width: 260px;
  }
`;

export interface ErrorModalContentProps {
  title?: string;
  message?: string;
}

export default function ErrorModalContent({ title, message }: ErrorModalContentProps) {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(hideModal());
  };

  return (
    <ContentWrapper>
      <ErrorIcon>
        <GenericErrorIcon />
      </ErrorIcon>
      <ModalTitle>{title || t("common.error.title")}</ModalTitle>
      <ModalMessage>{message || t("common.error.defaultMessage")}</ModalMessage>
      <ButtonGhost onClick={handleClose}>{t("common.button.ok")}</ButtonGhost>
    </ContentWrapper>
  );
}
